import { Component, Input } from '@angular/core';

@Component({
  selector: 'toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.css'],
  standalone: false
})
export class ToggleButtonComponent {
    @Input() checked: boolean;
    @Input() label: string;
}